import { gql } from '../../core/graphql-client.js';
import { auth } from '../../core/auth-store.js';
import { router } from '../../core/router.js';
import type { AuthResult } from '../../types.js';

export class VerifyPage extends HTMLElement {
  connectedCallback(): void {
    this.innerHTML = `
      <div class="page" style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100vh;gap:16px;">
        <loading-spinner text="Weryfikacja..."></loading-spinner>
        <div id="verify-error" style="display:none;text-align:center;">
          <p id="verify-msg" style="color:var(--color-error);margin-bottom:16px;"></p>
          <button class="btn btn-secondary" id="back-btn">Wróć do logowania</button>
        </div>
      </div>
    `;

    const token = this.getAttribute('token');
    if (!token) {
      this.showError('Brak tokena w URL');
      return;
    }

    this.verify(token);

    this.querySelector('#back-btn')!.addEventListener('click', () => {
      router.navigate('/login');
    });
  }

  private async verify(token: string): Promise<void> {
    try {
      const data = await gql.query<{ verifyMagicLink: AuthResult }>(
        `mutation($token: String!) {
          verifyMagicLink(token: $token) { sessionToken personId displayName isAdmin }
        }`,
        { token },
      );
      auth.login(data.verifyMagicLink);
      router.navigate(auth.isAdmin ? '/admin/dashboard' : '/availability');
    } catch (e) {
      this.showError(e instanceof Error ? e.message : 'Weryfikacja nie powiodła się');
    }
  }

  private showError(msg: string): void {
    const spinner = this.querySelector('loading-spinner');
    if (spinner) spinner.style.display = 'none';

    const errorDiv = this.querySelector('#verify-error') as HTMLElement;
    errorDiv.style.display = 'block';
    this.querySelector('#verify-msg')!.textContent = msg;
  }
}

customElements.define('verify-page', VerifyPage);
